<template>
  <div class="VaelgType">

    <h1 v-if     ="this.$store.getters.bookingInProgress.roomtype === 'vaerelse'">{{ $t('vaelgtype') }}</h1>
    <h1 v-else-if="this.$store.getters.bookingInProgress.roomtype === 'moedelokale'">{{ $t('vaelgmoede') }}</h1>
    <h1 v-else-if="this.$store.getters.bookingInProgress.roomtype === 'parkering'">{{ $t('vaelgparkering') }}</h1>
    <h1 v-else>{{ $t('vaelgtype') }}</h1>

    <!-- Vis 'loading' ikon mens API data loader... -->
    <img v-if="this.$store.getters.loading === true" src="@/assets/loading.svg" alt="">

<!-- <p>Checkin : {{ this.$route.params.checkin }}</p> -->
<!-- <p>Checkout: {{ this.$route.params.checkout }}</p> -->
<!-- <p>Occupancy: {{ this.$route.params.occupancy }}</p> -->
<!-- <span>Roomtype {{this.$store.getters.bookingInProgress.roomtype}}</span><br> -->
<!-- <p>Short code på første parkering: {{ this.$store.getters.rooms[0].short_code }}</p> -->
<!-- <p>Antal rooms: {{ this.$store.getters.rooms.length }}</p> -->
<!-- <p>Rooms: {{ this.$store.getters.rooms }}</p> -->
<!-- <p>Empty: {{ this.empty }}</p> -->
<!-- <span>bookingInProgress {{this.$store.getters.bookingInProgress}}</span><br> -->

    <splitBooking :roomAvailability="$store.getters.rooms" :hasSplitRooms="hasSplitRooms" />

    <div v-if="this.$store.getters.bookingInProgress.roomtype == 'vaerelse'" class="venteliste">
       <div v-if="this.totalAvailRooms == 0 && !hasSplitRooms()" class="ventelisteBox">
         <p class="ventelisteLinie">{{ $t('ventelisteText') }}</p>
         <p class="ventelisteLinie">{{ $t('navn') }}</p><input type="text" name="navn" v-model="venteliste.navn" class="ventelisteLinie">
         <p class="ventelisteLinie">{{ $t('email') }}</p><input type="text" name="email" v-model="venteliste.email" class="ventelisteLinie">
         <p class="ventelisteLinie">{{ $t('telefon') }}</p><input type="text" name="telefon" v-model="venteliste.telefon" class="ventelisteLinie">
         <a class="ventelisteLinie continueButton" style="width: 150px;" href="#" v-on:click="createVenteliste()">{{ $t('indsend') }}</a>
      </div>
    </div>


     <div v-if="this.$store.getters.bookingInProgress.roomtype == 'vaerelse'" class="flex-container">
       <div v-for="room in this.$store.getters.rooms" v-bind:key="room.short_code">
        <div class="roomBox" :class="['room-'+room.short_code]">
          <p class="heading">{{ $t(room.short_code)}}</p>
          <p class="subheading" v-if="getRoomToOrder($store.getters.bookingInProgress, room.short_code, 1) === 0" style="opacity: 0.2;">{{ $t('totalt') }} {{1 * room.total_price}} kr.</p>  <!-- Vis transparent pris ved antal=0 -->
          <p class="subheading" v-else>{{ $t('totalt') }} {{getRoomToOrder($store.getters.bookingInProgress, room.short_code, 1) * room.total_price}} kr.</p>                                <!-- Vis den aktuelle pris hvis der er valgt antal -->
          <div class="flex-container">
            <span v-if="hasSplitRooms(room.short_code) > 0">
              <div id="minus" v-on:click="subtractSplitRoomFromOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>
            <span v-else-if="getRoomToOrder($store.getters.bookingInProgress, room.short_code) > 0">
              <div id="minus" v-on:click="subtractRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>
            <span v-else>
              <div id="minus" class="grey" v-on:click="subtractRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>

            <p v-if="hasSplitRooms(room.short_code) > 0" class="availability splitAvailability">{{getRoomToOrder($store.getters.bookingInProgress, room.short_code, 1)}}</p>
            <p v-else class="availability">{{getRoomToOrder($store.getters.bookingInProgress, room.short_code, 1)}}</p>

            <span v-if="canOrderUnSplitRoom(room, room.short_code)">
              <div id="plus" v-on:click="addRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>
            <span v-else-if="canOrderSplitRoom(room, room.short_code)">
              <div id="plus" v-on:click="addSplitRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>
            <span v-else>
              <div id="plus" class="grey"></div>
            </span>

          </div>
            <p v-if     ="maxAvailability($store.getters.rooms, room.short_code) == 0 && !splitAvailable($store.getters.rooms, room.short_code)" class="maxAvailHit">{{$t('ikkeflereledige')}}</p>
            <p v-else class="maxAvailHit">&nbsp;</p>
        </div>
       </div>
    </div>

     <div v-if="this.$store.getters.bookingInProgress.roomtype == 'parkering'" class="flex-container">
       <div v-for="room in this.$store.getters.rooms" v-bind:key="room.short_code">
        <div class="roomBox room-p">
          <p class="heading">{{ $t('parkering') }}</p>
          <p class="subheading">{{ $t('totalt') }} {{getRoomToOrder($store.getters.bookingInProgress, room.short_code) * room.total_price}} kr.</p>
          <div class="flex-container">
            <span v-if="getRoomToOrder($store.getters.bookingInProgress, room.short_code) <= 0">
              <div id="minus" v-on:click="subtractRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>
            <span v-else>
              <div id="minus" v-on:click="subtractRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>

            <p class="availability">{{getRoomToOrder($store.getters.bookingInProgress, room.short_code)}}</p>

            <span v-if="getRoomToOrder($store.getters.bookingInProgress, room.short_code) >= maxAvailability($store.getters.rooms, room.short_code)">
              <div id="plus" class="grey" v-on:click="addRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>
            <span v-else>
              <div id="plus" v-on:click="addRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>
          </div>
            <p v-if="maxAvailability($store.getters.rooms, room.short_code) == 0" class="maxAvailHit">{{$t('ikkeflereledige')}}</p>
            <p v-else class="maxAvailHit">&nbsp;</p>
        </div>
       </div>
    </div>

     <div v-if="this.$store.getters.bookingInProgress.roomtype == 'moedelokale'" class="flex-container">
       <div v-for="room in this.$store.getters.rooms" v-bind:key="room.short_code">
        <div class="roomBox" :class="['room-'+room.short_code]">
          <p class="heading">{{ $t(room.short_code)}}</p>
          <p class="subheading">{{ $t('totalt') }} {{getRoomToOrder($store.getters.bookingInProgress, room.short_code) * room.total_price}} kr.</p>
          <div class="flex-container">
            <span v-if="getRoomToOrder($store.getters.bookingInProgress, room.short_code) <= 0">
              <div id="minus" v-on:click="subtractRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>
            <span v-else>
              <div id="minus" v-on:click="subtractRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>

            <p class="availability">{{getRoomToOrder($store.getters.bookingInProgress, room.short_code)}}</p>

            <span v-if="getRoomToOrder($store.getters.bookingInProgress, room.short_code) >= maxAvailability($store.getters.rooms, room.short_code)">
              <div id="plus" class="grey" v-on:click="addRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>
            <span v-else>
              <div id="plus" v-on:click="addRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>
          </div>
            <p v-if="maxAvailability($store.getters.rooms, room.short_code) == 0" class="maxAvailHit">{{$t('ikkeflereledige')}}</p>
            <p v-else>&nbsp;</p>
        </div>
       </div>
    </div>

     <div v-if="this.$store.getters.bookingInProgress.roomtype == 'selskabslokale'" class="flex-container">
       <div v-for="room in this.$store.getters.rooms" v-bind:key="room.short_code">
        <div class="roomBox" :class="['room-'+room.short_code]">
          <p class="heading">{{ $t(room.short_code)}}</p>
          <p class="subheading">{{ $t('totalt') }} {{getRoomToOrder($store.getters.bookingInProgress, room.short_code) * room.total_price}} kr.</p>
          <div class="flex-container">
            <span v-if="getRoomToOrder($store.getters.bookingInProgress, room.short_code) <= 0">
              <div id="minus" v-on:click="subtractRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>
            <span v-else>
              <div id="minus" v-on:click="subtractRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>

            <p class="availability">{{getRoomToOrder($store.getters.bookingInProgress, room.short_code)}}</p>

            <span v-if="getRoomToOrder($store.getters.bookingInProgress, room.short_code) >= maxAvailability($store.getters.rooms, room.short_code)">
              <div id="plus" class="grey" v-on:click="addRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>
            <span v-else>
              <div id="plus" v-on:click="addRoomToOrder($store.getters.bookingInProgress, room.short_code)"></div>
            </span>
          </div>
            <p v-if="maxAvailability($store.getters.rooms, room.short_code) == 0" class="maxAvailHit">{{$t('ikkeflereledige')}}</p>
            <p v-else>&nbsp;</p>
        </div>
       </div>
    </div>    

    <div class="buttonContainer">

      <a v-on:click="navigateBack()">
      <div class="continueButton">
          <p style="margin-top: 20px;">&#171; {{$t('tilbage')}}</p>
      </div>
    </a>    

    <!-- <router-link v-if="this.empty === 0" to="vilduVaelge"> -->
    <router-link v-if="this.empty == 0" :to="{ name: '5.1-vilDuVaelge', params: { la: this.locale} }">
      <div class="continueButton">
        <a>{{ $t('videre')}} &raquo;</a>
      </div>
    </router-link>

  <router-link v-else to="vaerelsestype">
    <div class="continueButton" style="opacity: 0.2;">
      <a>{{ $t('videre') }} &raquo;</a>
    </div>
  </router-link>

  </div>

  <!-- <p>rooms: <br>{{this.$store.getters.rooms}}</p> -->
  <!-- <p>Indhold af cart: <br>{{$store.getters.bookingInProgress}}</p> -->
  <!-- <p>Indhold af order: <br>{{$store.getters.bookingInProgress.needs}}</p>  -->
  <!-- <p>Værelsestype: {{ $store.getters.bookingInProgress.roomtype }}</p> -->
  </div>
</template>

<script>

import splitBooking from '../components/splitBooking.vue';
import i18n from '@/plugins/i18n';
var moment = require('moment');
moment.locale('da');

export default {
  components: {
    splitBooking
  },
  name: 'App',
  data () {
    return {
      locale: i18n.locale,
      item: {"test": 2},
      order: {'D': 1},
      needs: {},
      empty: 1,
      totalAvailRooms: -1,
      venteliste: {"navn": '', "email": '', "telefon": '', "postnr": '', "sprog": '', "koncern": '5406', "dato": {"startdate": '0000-00-00', "enddate": '0000-00-00'}},
      forceReRender: true,
    }
  },
  watch: {},
  created() {
    if(this.$store.getters.bookingInProgress.roomtype == 'ekstra') {
      this.$router.push({name: '6-ekstra'});
    }

    // sæt "tilbageside-huskeren" til 'slutDato' så vi senere bliver sendt tilbage til slutDato hvis 'vilDuVaelge' og 'ekstra'-siderne bliver sprunget over pga. manglende indhold
    //this.$store.dispatch("back", 'slutDato');

    // direkte link fix - hvis der bliver linket direkte ved vi ikke hvilken vaerelsestype der er valgt - saa vi defaulter til 'vaerelse'
    if( !this.$store.getters.bookingInProgress.roomtype ) {
      var name = 'roomtype';
      var value = 'vaerelse';
      this.$store.dispatch("addToCart", { name, value });
    }
    // Hvis Hotel er angivet i URL skal den anvendes
    if((typeof this.$route.params.hotel !== 'undefined') && this.$route.params.hotel != '') {
      this.changeBooking('hotel', this.$route.params.hotel);
    }

    // Hvis checkin/checkout er angivet i URL skal disse datoer anvendes
    if((typeof this.$route.params.checkin !== 'undefined') && (typeof this.$route.params.checkout !== 'undefined') && this.$route.params.checkin != '' && this.$route.params.checkout != '') {
      var checkin  = moment(this.$route.params.checkin);
      var checkout = moment(this.$route.params.checkout);
      if(checkin.isValid() && checkout.isValid()) {
        // Datoerne er validerede - gem nu disse i localstorage så datoerne virker som hvis den var valgt på de forrige sider
        this.changeBooking('startdate', this.$route.params.checkin)
        this.changeBooking('enddate'  , this.$route.params.checkout)
        // Hvis roomtype også er angivet i URL skal denne anvendes - ellers anvendes 'vaerelse' som default
        if(typeof this.$route.params.roomtype !== 'undefined' && this.$route.params.roomtype != '') {
          name = 'roomtype';
          value = this.$route.params.roomtype;
          this.$store.dispatch("addToCart", { name, value });
        } else {
          name = 'roomtype';
          value = 'vaerelse';
          this.$store.dispatch("addToCart", { name, value });

        }

      }
    }

    // Sæt roomtype
    var roomtype = 'r';
    if(this.$store.getters.bookingInProgress.roomtype == 'vaerelse') {
      roomtype = 'r'
    }
    if(this.$store.getters.bookingInProgress.roomtype == 'parkering') {
      roomtype = 'p'
    }
    if(this.$store.getters.bookingInProgress.roomtype == 'moedelokale') {
      roomtype = 'e'
    }
    if(this.$store.getters.bookingInProgress.roomtype == 'selskabslokale') {
      roomtype = 'E'
    }

    // Hent availability info om de værelsestyper der tilbydes
    this.$store.dispatch("getRoomData", {
      'roomType': roomtype,
      'hotel': this.$store.getters.bookingInProgress.hotel, 
      'koncern': this.$route.params.koncern,
      'start': this.$store.getters.bookingInProgress.startdate, 
      'end': this.$store.getters.bookingInProgress.enddate,
      'occupancy': this.$route.params.occupancy
      }).then(() => {
        this.nulstil(this.$store.getters.rooms)         // Nulstil valg
        this.noAvailability(this.$store.getters.rooms)  // Check antal ledige rooms, beslutter om venteliste skal vises
        if(this.$store.getters.loading === false) {
          // Hvis værelsestype er parkering eller selskabslokale, og der kun er 1 parkerings-type at vælge imellem, så sæt til 1 hvis der er ledige, og send brugeren til "6-ekstra"
          if((this.$store.getters.bookingInProgress.roomtype == 'parkering' || this.$store.getters.bookingInProgress.roomtype == 'selskabslokale') && this.$store.getters.rooms.length === 1) {
            if (this.getRoomToOrder(this.$store.getters.bookingInProgress, this.$store.getters.rooms[0].short_code) < this.maxAvailability(this.$store.getters.rooms, this.$store.getters.rooms[0].short_code)) {
              this.addRoomToOrder(this.$store.getters.bookingInProgress, this.$store.getters.rooms[0].short_code).then(() => {
                this.$store.dispatch("back", 'slutDato'); // Gem denne sides url i Vuex, så vi ved hvilken side vi skal navigere til på 'tilbage'-knappen
                this.$router.replace({ path: "5.1-vilDuVaelge" });
              });
              //console.log('Sætter parkering til 1');
            } else {
              // Gør intet, vi viser "ikke flere ledige" teksten på roombox
              //console.log('Der er ingen ledige parkeringspladser');
            }
          }
        } else {
          console.log("Loader stadig API");
        }
        console.log("Needs: " + JSON.stringify(this.$store.getters.rooms));
      });
  },
  mounted() {
  },
  beforeUpdate() {
  },
  methods: {
    testMethod(short_code, message) {
      console.log("testMethod() aktiveret, short_code: " + short_code + ", besked: "+message);
      //console.log("testMethod()"+JSON.stringify(this.$store.getters.rooms));
      return true;
    },
    /* Nulstiller typevalg */
    nulstil(needs) {
      var name = 'needs';
      var value = {};

      for (var key in needs) {
        if(needs.hasOwnProperty(key)) {
          console.log(key + " -> " + needs[key].short_code);
          value[needs[key].short_code] = 0;
        }
      }
      console.log('Sætter '+name+': '+JSON.stringify(value));
      this.$store.dispatch("addToCart", {name, value});

      // Nulstil split-bookings her
      // sæt split-objektet til 0, eller fjern det helt
      console.log('5-vaelgType: nulstil() - Sætter split til empty');
      var splitName = 'split';
      var splitValue = {};
      this.handleOrderChange(splitName, splitValue);
    },
    // Denne sætter this.empty til 1 hvis der ikke er bestilt noget
    isOrderNotEmpty(needs, bookingInProgress, short_code) {
      var total = 0;
      for (var key in needs) {
        if(needs.hasOwnProperty(key)) {
          if(needs[key] > 0) {
            total++;
          }
        }
      }
      if(total === 0 && !this.hasSplitRooms(short_code)) {
        this.empty = 1;
        console.log(`isOrderNotEmpty: sætter empty til 1, hasSplitRooms: ${this.hasSplitRooms(short_code)}`);
      } else {
        this.empty = 0;
        console.log("isOrderNotEmpty: sætter empty til 0");
      }
    },

    isOrderNotEmptySplit(needs, bookingInProgress, short_code) {
      //this.isOrderNotEmpty(needs);

      if(this.hasSplitRooms(short_code)) {
        //console.log("isOrderNotEmptySplit: sætter empty til 0");
        this.empty = 0;
      }
    },

    /* Registrer en ændring i state i Vuex store */
    handleOrderChange(name, order) {
      var value = order;
      console.log('Sætter '+name+': '+JSON.stringify(value));

      // Send ændring til Vuex store
      var addToCart = this.$store.dispatch("addToCart", {name, value}).then(() => {
        // Check om der er foretaget en bestilling
        this.isOrderNotEmpty(value);
      })

      return addToCart;
    },
    /* Tilføj '1' til den angivne værelsestype */
    addRoomToOrder(bookingInProgress, short_code) {
      console.log('kører addRoomToORder()');
      var i = 0;
      var found = 0;
      var order = bookingInProgress.needs;
      var total = Object.keys(order).length;
      var maxAvail = null;

      // Hvis der er udsolgt så sæt availability til hvad vi kan opnå ved at splitte værelser op
      if (this.maxAvailability(this.$store.getters.rooms, short_code) == 0) {
        maxAvail = this.splitAvailable(this.$store.getters.rooms, short_code, true)
      } else {
        maxAvail = this.maxAvailability(this.$store.getters.rooms, short_code)
      }

      for (var key in order) {
        i++;
        if (order.hasOwnProperty(key)) {
          if (key == short_code) {
            if(order[key] < maxAvail) {
              if(typeof order[key] !== 'undefined') {
                order[key]++;
                found++;
              } else {
                order[key] = 1;
                found++;
              }
            } else {
              order[key] = maxAvail;
              found++;
            }
          }
        }
      }
      if(i == total && found == 0) {
        order[short_code] = 1;
      }

      return this.handleOrderChange('needs', order);
    },
    /* Fjern '1' fra den angivne værelsestype */
    subtractRoomToOrder(bookingInProgress, short_code) {
      var i = 0;
      var found = 0;
      var order = bookingInProgress.needs;
      var total = Object.keys(order).length;

      for (var key in order) {
        i++;
        if (order.hasOwnProperty(key)) {
          if (key == short_code) {
            if(order[key] > 0) {
              if(typeof order[key] !== 'undefined') {
                order[key]--;
                found++;
              } else {
                order[key] = 0;
                found++;
              }
            }
          }
        }
      }
      if(i == total && found == 0) {
        order[short_code] = 0;
      }

      this.handleOrderChange('needs', order);
    },
    /** hvis der er valgt splitRooms, så returner antallet */
    hasSplitRooms(short_code = null) {
      var bookingInProgress = this.$store.getters.bookingInProgress;  // DENNE FIK this.empty TIL AT STÅ RIGTIGT!!!!!!!!!
      var totalSplits = 0;
      if(short_code === null) {
        if(typeof bookingInProgress.split === 'object') {
          const short_codes = Object.keys(bookingInProgress.split);
          short_codes.forEach(short_code => {
            //const splitValue = bookingInProgress.split[short_code];
            totalSplits += bookingInProgress.split[short_code].length;
          })
          console.log('1Der er splittet rooms, antal: '+totalSplits);
          return totalSplits;
        } else {
          console.log('2hasSplitRooms(): Der er ikke splittet rooms...');
          return 0;
        }
      } else {
        if( typeof this.$store.getters.bookingInProgress.split === 'object' && Array.isArray(this.$store.getters.bookingInProgress.split[short_code])) {
          totalSplits += this.$store.getters.bookingInProgress.split[short_code].length;
          console.log('hasSplitRooms: '+JSON.stringify(this.$store.getters.bookingInProgress.split));
          console.log('3Der er splittet rooms, antal: '+totalSplits);
          return totalSplits;
        } else {
          console.log(`4hasSplitRooms(): Der er ikke splittet rooms... short_code: ${short_code}, bookingInProgress.split: ${JSON.stringify(this.$store.getters.bookingInProgress.split[short_code])} from getter: ${JSON.stringify(this.$store.getters.bookingInProgress.split)}`);
          return 0;
        }
      }
    },
  canOrderUnSplitRoom(room, short_code) {
      const bookingInProgress = this.$store.getters.bookingInProgress;
      const rooms = this.$store.getters.rooms;
      const orderedRooms = this.getRoomToOrder(bookingInProgress, room.short_code);
      const maxRooms = this.maxAvailability(rooms, room.short_code);
      console.log(`canOrderUnSplitRoom: Type: ${short_code}, Ordered Rooms: ${orderedRooms}, Max Rooms: ${maxRooms}`);
      return orderedRooms < maxRooms;
  },
  canOrderSplitRoom(room, short_code) {
    const bookingInProgress = this.$store.getters.bookingInProgress;
    const rooms = this.$store.getters.rooms;
    const orderedRooms = this.getRoomToOrder(bookingInProgress, room.short_code, 1);
    const maxRooms = this.maxAvailability(rooms, room.short_code);
    const splitRooms = this.splitAvailable(rooms, room.short_code, true);
    console.log(`canOrderSplitRoom: Type: ${short_code}, Ordered Rooms: ${orderedRooms}, Max Rooms: ${maxRooms}, Split Rooms: ${splitRooms}`);
    return orderedRooms < (maxRooms + splitRooms);
  },
    /** Fjerner sidste opsplittede booking fra listen */
    subtractSplitRoomFromOrder(bookingInProgress, short_code) {
      //console.log('subtractSplitRoomFromOrder: antal _før_ subtract: '+this.hasSplitRooms(short_code));
      var order = null;
      //this.empty=1; // Denne skal stå sådan for at -/+-knapperne virker - jeg ved ikke hvorfor!
      if(Array.isArray(bookingInProgress.split[short_code])) {
        order = bookingInProgress.split[short_code];
        // Fjern sidste array fra order
        if(Array.isArray(order) && order.length > 0) {
          order.pop();
        } else {
          //bookingInProgress.split[short_code] = null;
          order[short_code] = null;
          //this.$store.dispatch("addSplitBookingToCart", {name: short_code, value: null});
        }
      } else {
        //bookingInProgress.split[short_code] = null;
        order = [];
      }
      //console.log('subtractSplitRoomFromOrder: antal _efter_ subtract: '+this.hasSplitRooms(short_code));
      
      // skriv ordre i Vuex
      this.$store.dispatch("addSplitBookingToCart", {name: short_code, value: order});

      // Check om der er foretaget en bestilling
      //this.isOrderNotEmptySplit(bookingInProgress.needs, bookingInProgress, short_code);
      this.isOrderNotEmpty(bookingInProgress.needs, bookingInProgress, short_code);
    },
    /** indsæt et opdelt room */
    addSplitRoomToOrder(bookingInProgress, short_code) {
      //console.log('kører addSplitRoomToORder()');

      var order = null;
      //this.empty=0; // Denne skal stå sådan for at -/+-knapperne virker - jeg ved ikke hvorfor!
      if(Array.isArray(bookingInProgress.split[short_code])) {
        order = bookingInProgress.split[short_code];
        //this.empty=0; // Vi sætter this.empty manuelt, for at 'videre'-knappen bliver aktiveret
      } else {
        order = [];
      }

      // Hent de muligheder for opdeling af værelse APIet har genereret
      var thisRoomSplitOptions = null;
      this.$store.getters.rooms.forEach(function (room) {
        if (room.short_code == short_code) {
          thisRoomSplitOptions = room.split;
        }
      });

      /**
       * pseudo:
       * - tæl hvor mange split arrays vi allerede har booket (arrays as objekter i bookingInProgress.split)
       * - find antal fra ovenstående +1 og brug denne key
       * - tag availability-split-options med key fra ovenstående
       * - indsæt denne availability-split-option som køb i bookingInProgress.split
       */

      // gennemgå thisRoomSplitOptions én for én - hvis den første allerede findes i order[] så spring videre ind til vi kan indsætte en unik.
      // Hvis vi ikke kan finde en unik er der ikke mere availability
      for (const splitOption of thisRoomSplitOptions) {
        console.log('Tester om: '+JSON.stringify(order)+' indeholder entry der er identisk med: '+JSON.stringify(splitOption))
        const indexOfExistingOrder = this.findIdenticalArrayIndex(splitOption, order);
        if (indexOfExistingOrder === -1) {
          //thisOrder = splitOption;
          //console.log('... det gør den ikke - lægger til ordren.');
          order.push(splitOption);
          break;
        } else {
          //console.log('Denne findes allerede - springer over...');
        }
      }
      //console.log('antal booket med split nu: '+order.length);

      // skriv ordre i Vuex
      this.$store.dispatch("addSplitBookingToCart", {name: short_code, value: order}).then(() => {
        // Check om der er foretaget en bestilling, og sæt this.empty derefter
        this.isOrderNotEmpty(bookingInProgress.needs, bookingInProgress, short_code);
      });

      // Check om der er foretaget en bestilling - sætter this.empty som bestemmer om "videre"-knappen skal være aktiv
      //this.isOrderNotEmpty(order); - vi kan ikke bruge denne, da 'order' er i et forkert format, orderNotEmppty() forventer et 'needs'-objekt



    },
    findIdenticalArrayIndex(needle, haystack) {
      for (let i = 0; i < haystack.length; i++) {
        if (this.areArraysEqual(needle, haystack[i])) {
          return i;
        }
      }
      return -1; // Return -1 if no identical array is found in the haystack
    },
    areArraysEqual(array1, array2) {
      // Check if either array1 or array2 is null or undefined
      if (array1 === null || array2 === null || array1 === undefined || array2 === undefined) {
        return false;
      }

      if (array1.length !== array2.length) {
        return false;
      }

      for (let i = 0; i < array1.length; i++) {
        if (typeof array1[i] === 'object' && typeof array2[i] === 'object') {
          if (!this.areObjectsEqual(array1[i], array2[i])) {
            return false;
          }
        } else if (array1[i] !== array2[i]) {
          return false;
        }
      }

      return true;
    },
    areObjectsEqual(obj1, obj2) {
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (const key of keys1) {
        if (obj1[key] !== obj2[key]) {
          return false;
        }
      }

      return true;
    },
    /* Returnér antal værelser, af den angivne type, der er bestilt */
    getRoomToOrder(bookingInProgress, short_code, split=0) {
      for (var key in bookingInProgress.needs) {
        if(bookingInProgress.needs.hasOwnProperty(key)) {
          if(key == short_code) {
            //console.log('getRoomToOrder: returnerer '+bookingInProgress.needs[key]+' er det < '+this.maxAvailability(this.$store.getters.rooms, short_code)+' ?');
            if(split === 0) {
              //console.log('getRoomToOrder: returnerer '+bookingInProgress.needs[key]);
              return bookingInProgress.needs[key];
            } else {
              //console.log('getRoomToOrder: returnerer '+parseInt(bookingInProgress.needs[key]+this.hasSplitRooms(bookingInProgress, short_code)));
              return parseInt(bookingInProgress.needs[key]+this.hasSplitRooms(short_code)); // her tillægges splittede værelser
            }
          }
        }
      }
    },
    /* Returnér max availability for den angivne type (uden split af rooms)*/
    maxAvailability(rooms, short_code) {
      var retVal = null;
      
      rooms.forEach(function (room) {
        if (room.short_code == short_code) {
          retVal = room.availability;
        }
      });
            
      return retVal;
    },

    /**
     * Der skal laves helt seperate datastrukturer for split bookings, da der alle steder
     * er taget udgangspunkt i start/slutdato og rooms.
     * Der skal laves seperate add/remove metoder og seperate arrays i roomsToBook
     * 
     * Start med at lave nyt felt i Vuex bookingInProgress (splitBooking)
     * - indhold:
     * - key (nummerisk fortløbende pr booking)
     * - startdato, slutdato, roomnr
     * Denne kan der så slås op i når der fremad i bookingen er konstateret at 
     * vi arbejder med en splitbooking.
     * Da den bruger sin egen datastruktur skal splitbooking have egne metoder
     * til at tilføje/slette data i bookingen
     */
    /** returnerer hvor mange rooms vi kan sælge hvis vi splitter op */
    splitAvailable(rooms, short_code, returnAvail = false) {
      let retVal = false;
      
      rooms.forEach((room) => {
        if (room.short_code === short_code) {
          if (Array.isArray(room.split) && room.split.length > 0) {
            if (returnAvail) {
              retVal = room.split.length;
              return retVal;  // Early return if we only need the count
            } else {
              retVal = true;
            }
          }
        }
      });
      
      return retVal;
    },
    changeBooking(name, value) {
      console.log('Sætter '+name+': '+value);
      this.$store.dispatch("addToCart", {name, value});
    },
    /**
     * Check om der er ledige værelser, skriv antal til this.totalAvailRooms
     */
    noAvailability(rooms) {
      var totalAvailRooms = 0;
      if(this.$store.getters.bookingInProgress.roomtype == 'vaerelse') {
        rooms.forEach((room) => {
          if(this.maxAvailability(this.$store.getters.rooms, room.short_code) > 0) {
            totalAvailRooms++;
          } else if(this.splitAvailable(this.$store.getters.rooms, room.short_code, true)) {
            totalAvailRooms = totalAvailRooms+this.splitAvailable(this.$store.getters.rooms, room.short_code, true);
          }
        });
      }

      this.totalAvailRooms = totalAvailRooms;
    },
    createVenteliste() {
      this.venteliste.postnr = this.$store.getters.bookingInProgress.hotel;
      this.venteliste.sprog = this.locale;
      this.venteliste.dato.startdate = this.$store.getters.bookingInProgress.startdate;
      this.venteliste.dato.enddate = this.$store.getters.bookingInProgress.enddate;
      this.$store.dispatch("saveVenteliste", this.venteliste);
    },
    navigateBack() {
        this.$router.push({path: `/${this.locale}/${this.$route.params.koncern}/hotel/${this.$route.params.hotel}/slutdato`});
      },
  },
}
</script>

<style scoped>

.ventelisteBox {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  padding: 15px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.ventelisteLinie {
  margin-bottom: 5px;
  flex: 25%;
  align-self: center;
}

.venteliste {
  background-color: rgba(255,255,255,0.87);
  color: black;
  max-width: 300px;
  margin: auto;
  margin-bottom: 150px;
}

h1 {
  font-size: 400%;
  margin-bottom: 120px;
  font-weight: normal;
}

.heading {
  font-size: 170%;
  margin-bottom: 40px;
  margin-top: -70px;
  height: 20px;
}

.subheading {
  font-size: 160%;
  margin-top: 10px;
  text-transform: none;
}

.availability {
  font-size: 250%;
  margin-top: -3px;
  margin-left: 30px;
  margin-right: 30px;
}

.splitAvailability {
  color: red;
}


.maxAvailHit {
  font-size: 100%;
  margin-top: -35px;
  text-transform: none;
  color: red;
  
}

.flex-container {
  padding: 0px;
  margin: -10px;
  list-style: none;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

.roomBox {
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 330px;
  height: 250px;
  box-sizing: border-box;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 100px;
  margin-top: 0px;
  margin-left: 20px;
  margin-right: 20px;
}

:before {
  --url: url("../assets/fireseng-ikon.gif");
}

/* Catch-all, som angiver default ikon hvis vi viser en værelsestype vi ikke har en CSS for */

[class^='room']:before {
  /* content: url("../assets/enkeltseng-ikon.gif"); */
  /* content: url("http://bookingapi.udvikling.bbhotels.dk:81/storage/ikon-1.png"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-1.png");
  transform: scale(.5);
  -webkit-transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-1:before {
  /* content: url("../assets/enkeltseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-1.png");
  transform: scale(.5);
  -webkit-transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-2:before {
  /* content: url("../assets/toseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-2.png");
  transform: scale(.5);
  -webkit-transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-D:before {
  /* content: url("../assets/Dobbeltseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-D.png");
  transform: scale(.5);
  -webkit-transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-H:before {
  /* content: url("https://bookingapi2.bbhotels.dk/storage/ikon-D2.png"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-H.png");
  margin-top: -150px;
  display: block;
}

.room-BH:before {
  /* content: url("https://bookingapi2.bbhotels.dk/storage/ikon-D2.png"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-BH.png");
  margin-top: -125px;
  display: block;
}

.room-3:before {
  /* content: url("../assets/treseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-3.png");
  transform: scale(.5);
  -webkit-transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-4:before {
  /* content: url("../assets/fireseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-4.png");
  transform: scale(.5);
  -webkit-transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-6:before {
  /* content: url("../assets/fireseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-6.png");
  transform: scale(.5);
  -webkit-transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-L:before {
  /* content: url("../assets/enkeltseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-L.png");
  transform: scale(.5);
  -webkit-transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-p:before {
  /* content: url("../assets/enkeltseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-P.png");
  transform: scale(.5);
  -webkit-transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-C:before {
  /* content: url("../assets/enkeltseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-C.png");
  transform: scale(.5);
  -webkit-transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.room-S:before {
  /* content: url("../assets/enkeltseng-ikon.gif"); */
  content: url("https://bookingapi2.bbhotels.dk/storage/ikon-S.png");
  transform: scale(.5);
  -webkit-transform: scale(.5);
  margin-top: -150px;
  display: block;
}

.ventelisteContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 100px;
}

.buttonContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 50px;
}

.continueButton {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 280px;
  height: 80px;  
  font-size: 150%;
  letter-spacing: 1px;
  padding-left: 10px;
  padding-right: 10px;
  margin: 20px;
  white-space: nowrap;
  flex: 0 0 100%;
  cursor: pointer;
}

a {
  text-decoration: none;
  color: black;
  text-align: center;
  line-height: 80px;
}

#plus {
   width: 40px;
   height: 40px;
   position: relative;
   border-radius: 50%;
   background: #004072;
   z-index: 2;
}

.grey {
   filter: opacity(20%);
}

#plus:before, #plus:after {
  content: "";
  position: absolute;
  z-index: 1;
  background: white;
  border-radius: 50px;
}

#plus:before {
  left: 50%;
  width: 15%;
  margin-left: -7%;
  margin-top: 10%;
  height: 80%;
}

#plus:after {
  top: 50%;
  height: 15%;
  margin-top: -7%;
  margin-left: -40%;
  align-items: center;
  width: 80%;
}

#minus {
   width: 40px;
   height: 40px;
   position: relative;
   border-radius: 50%;
   background: #004072;
   z-index: 2;
}

#minus:after {
  content: "";
  position: absolute;
  z-index: 1;
  background: white;
  border-radius: 50px;
}

#minus:after {
  top: 50%;
  height: 15%;
  margin-top: -7%;
  margin-left: -40%;
  align-items: center;
  width: 80%;
}

/* når viewport er mindre end 960 px */
@media (max-width: 959px) {
  /* Mindre overskrift */
  h1 {
    font-size: 200%;
    margin-bottom: 90px;
  }

  /* "Videre"-knappen centreres */
  .continueButton {
  float: none;
  display: inline-block;
  margin-left: 20px;
  }

  /* Vi sætter width til 100% på mobil, så vi ikke risikerer sidelæns scrollbars på smalle skærme */
  .roomBox {
    width: 100%;
    max-width: 330px;
    transform: scale(0.8);
    margin-bottom: 30px;
  }

  .continueButton {
    transform: scale(0.8);
    width: 140px;
    padding-left: 5px;
    padding-right: 5px;
    margin-left: 5px;
    margin-right: 5px;
  }
}


/* Fanger MS-Edge (præ-chrome renderer) specifikt - "ikke flere ledige" bliver vist for højt i Edge */
/* @supports (-ms-ime-align: auto) {
  .maxAvailHit {
    margin-top: 15%;
  }
} */

</style>
